import store from "../redux/store";
import { removePhoneNumberFormatting } from "./utilPhoneNumbers";

export const generateUuid = () => {
  // generate uuid in this format xxxx-xxxx include numbers and characters
  const chars = "0123456789abcdefghijklmnopqrstuvwxyz";
  let uuid = "";
  for (let i = 0; i < 8; i++) {
    if (i === 4) {
      uuid += "-";
    }
    const randomIndex = Math.floor(Math.random() * chars.length);
    uuid += chars[randomIndex];
  }
  return uuid;
};

export const contactsToUIFormat = (contacts) => {
  if (!contacts) {
    return [];
  }

  return contacts.map((contact) => {
    const emailDestinationIndex = contact.destinations.findIndex((destination) => destination.type === "email");
    var email = "";
    if (emailDestinationIndex !== -1) {
      email = contact.destinations[emailDestinationIndex].value;
    }

    const filteredDestinations = contact.destinations.filter((destination) => destination.type !== "email");

    return {
      contactId: contact.contactId,
      name: contact.name,
      description: contact.description,
      email: email,
      destinations: filteredDestinations,
      dtmfShortcutKey: contact.dtmfShortcutKey,
      isDefault: contact.isDefault,
    };
  });
};

export const contactsUiToContacts = (contacts) => {
  const { organizationId, accountId, setupId } = store.getState().info;

  if (!contacts) {
    return [];
  }

  return contacts.map((contact) => {
    // Process destinations to handle email logic
    let destinations = contact.destinations.filter(
      (destination) => !(destination.type === "email" && destination.value === "")
    );

    // Move email destination to the end if it exists and has a non-empty value
    const emailDestinationIndex = destinations.findIndex((destination) => destination.type === "email");
    if (emailDestinationIndex !== -1) {
      const [emailDestination] = destinations.splice(emailDestinationIndex, 1);
      destinations.push(emailDestination);
    }

    // Map the processed destinations with formatting applied
    destinations = destinations.map((destination) => {
      return {
        type: destination.type,
        value: destination.type === "phone_number" ? removePhoneNumberFormatting(destination.value) : destination.value,
        transferType: destination.transferType,
      };
    });

    return { ...contact, destinations: destinations };
  });
};
